<template>
<div>
    <div class="important">Roles</div>
    <!-- SEARCH -->
    <div class="im-search mt-3 mb-1">
        <div class="d-flex">
            <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
            <v-btn class="mx-1" color="primary" style="height: 30px" @click="openRoleCreateModal">Add Role</v-btn>
        </div>
        <div class="d-flex mx-1 py-2 fields align-center">
            <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
            <v-btn v-for="field in search_fields" :key="field.value" smal rounded depressed :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                <span class="text-capitalize caption">{{field.text}}</span>
            </v-btn>
        </div>
    </div>
    <!-- ./ SEARCH -->
    <!--data table-->
    <v-card tile flat class="mx-1">
        <im-table-header class="mt-2" :items="im_header" @clickSort="sortField($event)" style="background-color: #f5f5f5;" />
    </v-card>
    <!--./ data table -->

    <!--./ data table -->
    <div class="mx-1" style="position: relative; height: 3px">
        <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
    </div>

    <!-- DATATABLE ROWS -->
    <v-card tile flat class="mx-1" style="background-color: transparent !important;">
        <!-- <v-data-iterator :items="roles" :pagination.sync="pagination" :total-items="total" :rows-per-page-items="rppi"> -->
        <v-data-iterator :items="roles" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
            <template v-slot:default="props">
                <template v-for="item in props.items">
                    <v-row class="im-result regular" style="background-color: #f5f5f5;" no-gutters align="center">
                        <v-col cols="1" class="px-1">
                            <div>{{ item.id}}</div>
                        </v-col>
                        <v-col cols="3" class="px-2">
                            <div>{{ item.slug}}</div>
                        </v-col>
                        <v-col cols="3" class="px-2">
                            <div>{{ item.name}}</div>
                        </v-col>
                        <v-col cols="4" class="px-2">
                            <div>{{ item.description }}</div>
                        </v-col>
                        <v-col cols="1">
                            <v-icon class="px-1" @click="openRoleEditModal(item)">edit</v-icon>
                            <v-icon class="px-1" color="red" @click="openRoleDeleteModal(item)">delete</v-icon>
                        </v-col>
                    </v-row>
                </template>
            </template>
            <template v-slot:no-data>
                <v-alert :value="true" type="info" color="primary">
                    No data available.
                </v-alert>
            </template>
        </v-data-iterator>
    </v-card>


    <!-- role dialog-->
    <v-dialog v-model="role_dialog" max-width="640px" persistent>
        <v-form ref="role_form" v-model="valid_role" lazy-validation>
            <v-card>
                <v-card-text>
                    <v-text-field label="Slug" v-model="role.slug" :rules="role_rules.slug" required hint="Slug must be a unique, cannot contain blank characters." persistent-hint />
                    <v-text-field label="Name" v-model="role.name" :rules="role_rules.name" required hint="Role name." persistent-hint />
                    <v-text-field label="Description" v-model="role.description" :rules="role_rules.description" required hint="Role description." persistent-hint />
                    <small>* indicates a required field</small>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="exitRole()">Cancel</v-btn>
                    <v-btn color="primary" @click="addRole()" :disabled="!valid_role">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
    <!--./ role dialog-->

    <!--delete role dialog-->
    <v-dialog v-model="delete_role_dialog" max-width="320px">
        <v-card>
            <v-card-text class="pt-2">
                Are you sure you want to delete this role?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="delete_role_dialog=false">Cancel</v-btn>
                <v-btn dark color="red" @click="removeRole()">Delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./delete role dialog -->

</div>
</template>

<script>
import defaults from "../../utils/PropDefaults.js";
import IMTableHeader from '../../utils/IMTableHeader.vue';

export default {
    components: {
        'im-table-header': IMTableHeader,
    },

    props: {
        service_id: {
            type: Number
        },

    },
    data() {
        return {

            role: {
                slug: '',
                name: '',
                description: ''
            },

            // modals
            role_dialog: false,
            delete_role_dialog: false,

            // search
            sort_field_item: null,
            sort_field_dir: null,
            search: null,
            search_timeout: 500,
            search_fields: [
                {
                    text: 'Slug',
                    value: 'slug',
                    selected: true
                }, {
                    text: 'Name',
                    value: 'name',
                    selected: true
                }, {
                    text: 'Description',
                    value: 'description',
                    selected: true
                }
            ],

            //table
            loading: false,
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 25, 50, 100],

            im_header: [{
                    text: "Id",
                    width: "8.3%",
                    sortable: false,
                }, {
                    text: "Slug",
                    width: "25%",
                    sortable: true,
                    sort_order: 'slug',
                    sort_dir: null,
                }, {
                    text: "Name",
                    width: "25%",
                    sortable: true,
                    sort_order: 'name',
                    sort_dir: null,
                }, {
                    text: "Description",
                    width: "33.4%",
                    sortable: true,
                    sort_order: 'description',
                    sort_dir: null,
                }, {
                    text: "Actions",
                    width: "8.3%",
                    sortable: false,
                },
            ],

            //props
            roles: [],
            role_rules: {
                slug: [
                    v => !!v || 'Slug is required',
                    v => /^[A-Za-z0-9]+(?:_[A-Za-z0-9]+)*$/.test(v) || 'Not a valid slug.'
                ],
                name: [v => !!v || 'Name is required.'],
                description: [v => !!v || 'Description is required.'],
            },

            //validation
            valid_service: false,
            valid_role: false,


        }
    },
    watch: {
        service_id: {
            handler() {
                this.getRoles();
            }
        },
        page: {
            handler() {
                this.getRoles();
            }
        },
        size: {
            handler() {
                this.getRoles();
            }
        },
        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getRoles, 500);
            }
        }
    },

    created() {
        this.getRoles();
    },

    methods: {
        getRoles() {
            if(!this.service_id) {
                return
            }
            // we are currently loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
            }

            //prepare sorting & direction params
            let orders = [];
            let dirs = [];
            if(this.sort_field_item) {
                dirs.push(this.sort_field_dir);
                orders.push(this.sort_field_item);
            }

            // prepare type filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });

            let service_id = [this.service_id];
            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/roles/roles';

            // setup query params
            let params = {
                params: {
                    search: search,
                    service_ids: service_id,
                    fields: fields,
                    size: this.size,
                    page: this.page,
                    order: orders,
                    dir: dirs,
                    stamp: stamp
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    // if the current stamp matches the received stamp, populate items
                    if(parseInt(this.current_stamp) === parseInt(response.data.meta.stamp)) {
                        this.roles = response.data.data;
                        this.total = response.data.pagination.total;
                    }
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        addRole() {
            // validate
            if(!this.$refs.role_form.validate()) {
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/roles/roles';

            // call update or save endpoints
            if(this.role.id) {
                this.$axios.put(endpoint + '/' + this.role.id, this.role) // eslint-disable-next-line
                    .then(response => {
                        this.page = 1;
                        this.getRoles();
                        this.emitSuccess('Role updated.');
                    })
                    .catch(error => {
                        console.error(error);
                    })
                    .finally(() => {
                        this.role_dialog = false;
                    });
            } else {
                let item_save = {
                    slug: this.role.slug,
                    name: this.role.name,
                    description: this.role.description,
                    service_id: this.service_id
                }
                this.$axios.post(endpoint, item_save) // eslint-disable-next-line
                    .then(response => {
                        this.page = 1;
                        this.getRoles();
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.role_dialog = false;
                    });
            }
        },

        removeRole() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/roles/roles';

            // call delete endpoint
            this.$axios.delete(endpoint + '/' + this.delete_role.id) // eslint-disable-next-line
                .then(response => {
                    this.page = 1;
                    this.getRoles();
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.delete_role_dialog = false;
                });
        },

        openRoleCreateModal() {
            this.role = this.$clone({
                slug: '',
                name: '',
                description: '',
                service_id: null
            });
            this.role_dialog = true;
        },

        openRoleEditModal(item) {
            this.role = this.$clone(item);
            this.role_dialog = true;
        },

        openRoleDeleteModal(item) {
            this.delete_role = this.$clone(item);
            this.delete_role_dialog = true;
        },

        // sort and search funtions

        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.page = 1;
                this.getRoles();
            }
        },

        sortField(sortItem) {
            this.sort_field_item = sortItem.sort_order;
            this.sort_field_dir = sortItem.sort_dir;
            this.page = 1;
            this.getRoles();
            this.dialog_mobile_sort = false;
        },

        exitRole() {
            this.role = this.$clone({
                slug: '',
                name: '',
                description: '',
                service_id: null
            });
            this.role_dialog = false;
        }

    }
}
</script>
